<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
        ></dx-grid>

        <v-dialog persistent v-model="updateDialog" max-width="800">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Voting Registration Form
                    <span class="ml-2 text-info"
                        >({{ rowClicked.formType }})</span
                    ></v-card-title
                >
                <v-layout row>
                    <v-layout column style="max-width: 50%;" class="mr-2">
                        <div style="overflow-y: auto; height: 375px;">
                            <v-layout
                                row
                                class="pa-1"
                                v-for="prop in getProperties(rowClicked)"
                            >
                                <div class="font-weight-medium mr-2 width-200">
                                    {{ prop.name }}:
                                </div>
                                <div>
                                    {{ prop.value }}
                                </div>
                            </v-layout>
                        </div>
                    </v-layout>
                    <v-layout column style="max-width: 50%;" class="ml-2">
                        <div
                            v-if="!rowClicked.pdfUrl"
                            class="text-danger font-weight-medium"
                        >
                            Missing PDF Form
                        </div>
                        <v-btn
                            class="mt-2"
                            @click="downloadPdf"
                            v-if="rowClicked.pdfUrl"
                        >
                            <v-icon color="red" left dark>mdi-file-pdf</v-icon>
                            PDF Form
                            <v-icon right>mdi-download</v-icon>
                        </v-btn>
                        <v-btn class="mt-2" @click="downloadSignature">
                            <v-icon color="red" left dark>mdi-image</v-icon>
                            Signature
                            <v-icon right>mdi-download</v-icon>
                        </v-btn>
                        <v-text-field
                            v-model="confirmation"
                            label="Confirmation"
                            class="my-2"
                            outline
                            hide-details
                        ></v-text-field>
                        <v-textarea
                            v-model="note"
                            label="Note"
                            class="mt-2"
                            rows="4"
                            outline
                            hide-details
                        ></v-textarea>
                        <v-select
                            v-model="status"
                            label="Status"
                            class="mt-3"
                            :items="['PENDING', 'SUBMITTED']"
                            hide-details
                        ></v-select>
                        <v-spacer></v-spacer>
                    </v-layout>
                </v-layout>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="updateDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn :loading="processing" color="success" @click="save">
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="votingDialog" max-width="1000">
            <voting-master-list-person
                :person="presonInfo"
                :reload="reload"
                :close="closeVotingDialog"
            ></voting-master-list-person>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { formatCurrency, except } from "../../utils/helpers.js";
import votingMasterListPerson from "./VotingMasterListPerson.vue";

export default {
    components: {
        votingMasterListPerson,
    },
    data: () => ({
        title: "Online Voting Registration Forms",

        actions: [],
        userBranch: "",
        url: "",
        regID: "",
        processing: false,

        selected: [],
        updateDialog: false,
        rowClicked: {},
        status: "",
        note: "",
        confirmation: "",

        votingDialog: false,
        presonInfo: {},

        columns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                },
                icon: (value) => {
                    switch (value) {
                        case "SUBMITTED":
                            return "mdi-check-circle";
                        case "PENDING":
                            return "mdi-clock";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    switch (value) {
                        case "SUBMITTED":
                            return "success";
                        case "PENDING":
                            return "#fdb400";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            // {
            //     label: "ID",
            //     field: "id",
            //     visible: true,
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                label: "First Name",
                field: "firstName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "lastName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "votingStatus",
                label: "Voting Status",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                template: "link-action-cell-template",
                showLink: (row) => {
                    return true;
                },
            },
            {
                label: "House Number",
                field: "houseNumber",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Street",
                field: "streetName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "type",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "accountID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "date",
                label: "Entered On",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Form Type",
                field: "formType",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cell Phone",
                field: "cellPhone",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {
        this.columns.find((c) => c.field == "votingStatus").linkAction = (
            row,
        ) => {
            this.openVotingDialog(row);
        };

        this.actions.push({
            text: "Show Submitted",
            type: "switch",
            action: this.onShowSubmittedChanged,
        });
    },
    beforeDestroy() {},
    methods: {
        async beforeSetupGrid() {
            this.url = "onlineVotingRegistrationForms?includeSubmitted=";
        },
        onShowSubmittedChanged(value) {
            if (value) {
                this.url =
                    "onlineVotingRegistrationForms?includeSubmitted=true";
            } else {
                this.url = "onlineVotingRegistrationForms?includeSubmitted=";
            }

            this.$refs.grid.reloadDataSource(this.url);
        },
        async onRowClicked(row) {
            this.rowClicked = row;
            this.status = row.status;
            this.note = row.note;
            this.confirmation = row.confirmation;
            this.updateDialog = true;
        },
        getProperties(data) {
            const sortBy = [
                "accountID",
                "type",
                "usCitizen",
                "nycResident",
                "firstName",
                "lastName",
                "middleInitial",
                "suffix",
                "dob",
                "gender",
                "phone",
                "emailAddress",
                "dmvNumber",
                "socialLast4",
                "houseNumber",
                "streetName",
                "apartment",
                "borough",
                "cityTownVillage",
                "zipCode",
                "mailingAddressState",
                "mailingAddress",
                "mailingAddressPoBox",
                "mailingAddressZipCode",
                "mailingAddressCityTownVillage",
                "haveYouVotedBefore",
                "votedBeforeYear",
                "nameWas",
                "addressWas",
                "stateOrCountyWas",
                "politicalParty",
            ];

            const fields = Object.keys(
                except(
                    data,
                    "signatureImageUrl",
                    "signatureBase64String",
                    "status",
                    "statusIcon",
                    "date",
                    "pdfUrl",
                    "id",
                ),
            )
                .map((key) => {
                    return {
                        originalKey: key, // Store the original key for sorting
                        name: this.formatField(key), // Formatted name for display
                        value: ["dob"].includes(key)
                            ? moment(data[key]).format("L")
                            : data[key],
                    };
                })
                .filter((p) => p.value)
                .sort((a, b) => {
                    // Get the index of each field's original key in the sortBy array
                    const indexA = sortBy.indexOf(a.originalKey);
                    const indexB = sortBy.indexOf(b.originalKey);

                    // If a field is not in sortBy, push it to the end
                    if (indexA === -1 && indexB === -1) return 0;
                    if (indexA === -1) return 1;
                    if (indexB === -1) return -1;

                    // Sort based on index in sortBy
                    return indexA - indexB;
                });

            return fields;
        },
        formatField(value) {
            // Step 1: Split camelCase/PascalCase by adding spaces before uppercase letters
            const spacedValue = value
                .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between lowercase and uppercase (e.g., FirstName -> First Name)
                .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2"); // Handle cases like "DOB" -> "D O B" then adjust

            // Step 2: Convert to title case (capitalize first letter of each word)
            return spacedValue
                .split(" ") // Split into words
                .map(
                    (word) =>
                        word.charAt(0).toUpperCase() +
                        word.slice(1).toLowerCase(),
                ) // Capitalize each word
                .join(" "); // Join back with spaces
        },
        async openVotingDialog(row) {
            if (row.personID == "No Ansl ID") {
                return this.$notify({
                    group: "notification",
                    text: "No Ansl ID",
                    type: "warning",
                });
            }

            this.presonInfo = await this.$http.get(
                "api/applicantStudents/getPersonByID?personID=" + row.personID,
            );

            this.votingDialog = true;
        },
        closeVotingDialog() {
            this.votingDialog = false;
        },
        reload() {
            this.$refs.grid.reloadGrid();
        },
        downloadPdf() {
            this.downloadPDF(this.rowClicked.pdfUrl);
        },
        downloadSignature() {
            window.open(this.rowClicked.signatureImageUrl);
        },
        async downloadPDF(url, fileName = "Pdf Form.pdf") {
            try {
                // Fetch the PDF file
                const response = await fetch(url);
                if (!response.ok)
                    throw new Error("Network response was not ok");

                // Convert the response to a blob
                const blob = await response.blob();

                // Create a temporary URL for the blob
                const blobUrl = window.URL.createObjectURL(blob);

                // Create a temporary link element
                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = fileName; // Set the file name for download

                // Append the link to the document, trigger click, and remove it
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Revoke the blob URL to free up memory
                window.URL.revokeObjectURL(blobUrl);
            } catch (error) {
                console.error("Failed to download PDF:", error);
            }
        },
        async save() {
            try {
                this.processing = true;

                this.rowClicked.status = this.status;
                this.rowClicked.note = this.note;
                this.rowClicked.confirmation = this.confirmation;

                await this.$http.post(
                    "api/onlineVotingRegistrationForms/save",
                    this.rowClicked,
                );

                this.processing = false;
                this.updateDialog = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.reload();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
.accounts-search.container {
    padding-top: 0px;
}
.yg-student-account-match {
    border: 2px solid #4caf50;
}
</style>
